exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-header[data-v-12991367] {\n  padding: 0;\n}\n.page-header[data-v-12991367] .ant-page-header-heading-title {\n  font-size: 14px;\n}\n", ""]);

// exports
